export const getNavigatorLanguage = () => {
  const found: string[] = [];

  if (typeof navigator !== 'undefined') {
    if (navigator.languages) {
      // chrome only; not an array, so can't use .push.apply instead of iterating
      for (let i = 0; i < navigator.languages.length; i++) {
        found.push(navigator.languages[i]);
      }
    }
    // @ts-expect-error
    if (navigator.userLanguage) {
      // @ts-expect-error
      found.push(navigator.userLanguage);
    }
    if (navigator.language) {
      found.push(navigator.language);
    }
  }

  return found;
};

export const normalizeLanguage = (language: string) => {
  if (language.startsWith('zh')) {
    return 'zh-Hans';
  }

  if (language.startsWith('en')) {
    return 'en';
  }

  if (language.startsWith('ja')) {
    return 'ja';
  }

  if (language.startsWith('ko')) {
    return 'ko';
  }

  if (language.startsWith('vi')) {
    return 'vi';
  }

  if (language.startsWith('es')) {
    return 'es';
  }

  if (language.startsWith('id')) {
    return 'id';
  }

  if (language.startsWith('ne')) {
    return 'ne';
  }

  if (language.startsWith('my')) {
    return 'my';
  }

  if (language.startsWith('pt')) {
    // pt-BR 需要特殊处理
    if (language.toLowerCase().includes('br')) {
      return 'pt-BR';
    }
    return 'pt';
  }

  return language;
};

export const normalizeLanguages = (languages: string[]) => {
  return languages.map(normalizeLanguage);
};
